import { NotificationTypes } from '../../../types'
import { TaskTypes } from './constants'

const getTaskTypeLabel = (taskType: TaskTypeKey) => {
   switch (taskType) {
      case 'ActionTasks':
         return 'Actions'
      case 'ReminderTasks':
         return 'Reminders'
      case 'InformationalTasks':
         return 'Info'
      case 'GlobalTasks':
      default:
         return 'Global'
   }
}

const getTaskTypeId = (taskType: TaskTypeKey) => {
   switch (taskType) {
      case 'ActionTasks':
         return NotificationTypes.Action
      case 'ReminderTasks':
         return NotificationTypes.Reminder
      case 'InformationalTasks':
         return NotificationTypes.Info
      case 'GlobalTasks':
      default:
         return NotificationTypes.Global
   }
}

const getTaskTypeFromType = (apiTaskType?: TaskTypes): NotificationTypes => {
   switch (apiTaskType) {
      case TaskTypes.ConnectionRequest:
      case TaskTypes.BorrowToolRequest:
      case TaskTypes.LoanToolRequest:
      case TaskTypes.ReturnRequest:
      case TaskTypes.TransferToolToRequest:
      case TaskTypes.TransferToolFromRequest:
         return NotificationTypes.Action
      case TaskTypes.CustomFieldReminder:
      case TaskTypes.RentalDueDateReminder:
      case TaskTypes.ToolDueDateReminder:
      case TaskTypes.ToolNoteCreated:
      case TaskTypes.ToolNoteDueDateReminder:
      case TaskTypes.ToolWarrantyReminder:
      case TaskTypes.ToolCreateReminder:
      case TaskTypes.ReorderLevelReminder:
         return NotificationTypes.Reminder
      case TaskTypes.AcceptConnectionRequest:
      case TaskTypes.DeclineConnectionRequest:
      case TaskTypes.AcceptedBorrowToolRequest:
      case TaskTypes.DeclineBorrowToolRequest:
      case TaskTypes.AcceptedLoanToolRequest:
      case TaskTypes.DeclineLoanToolRequest:
      case TaskTypes.AcceptedReturnRequest:
      case TaskTypes.DeclineReturnRequest:
      case TaskTypes.ReturnRequestNoResponse:
      case TaskTypes.SmartAuditNotification:
         return NotificationTypes.Info
      case TaskTypes.MassTransfer:
      default:
         return NotificationTypes.Global
   }
}

export { getTaskTypeLabel, getTaskTypeId, getTaskTypeFromType }
